import { cn } from "@/lib/utils"

interface TrilogyCardProps {
  number: string
  title: string
  subtitle: string
  description: string
  color: "amber" | "teal" | "slate"
}

const colorClasses = {
  amber: {
    bg: "bg-amber-600/5",
    border: "border-amber-600/20",
    number: "text-amber-500",
    hover: "hover:border-amber-600/40"
  },
  teal: {
    bg: "bg-teal-600/5",
    border: "border-teal-600/20",
    number: "text-teal-500",
    hover: "hover:border-teal-600/40"
  },
  slate: {
    bg: "bg-slate-500/5",
    border: "border-slate-500/20",
    number: "text-slate-400",
    hover: "hover:border-slate-500/40"
  }
}

export function TrilogyCard({ number, title, subtitle, description, color }: TrilogyCardProps) {
  const colors = colorClasses[color]
  
  return (
    <div className={cn(
      "relative p-6 rounded-xl border transition-all duration-300",
      colors.bg,
      colors.border,
      colors.hover
    )}>
      <div className="absolute top-4 right-4">
        <span className={cn("text-4xl font-bold opacity-20", colors.number)}>
          {number}
        </span>
      </div>
      
      <h4 className="text-lg font-semibold text-foreground mb-1">{title}</h4>
      <p className={cn("text-sm font-medium mb-3", colors.number)}>{subtitle}</p>
      <p className="text-sm text-muted-foreground leading-relaxed">{description}</p>
    </div>
  )
}
